import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getCurrentUser, signOut, fetchUserAttributes } from 'aws-amplify/auth';
import './Dashboard.css';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [attributes, setAttributes] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
      
      // 사용자 속성 가져오기
      const userAttributes = await fetchUserAttributes();
      setAttributes(userAttributes);
    } catch (error) {
      navigate('/signin');
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/signin');
    } catch (error) {
      console.error('로그아웃 중 오류 발생:', error);
    }
  };

  if (!user) {
    return <div>로딩 중...</div>;
  }

  return (
    <div className="dashboard-container">
      <h2>대시보드</h2>
      <div className="user-info">
        <h3>사용자 정보 :)</h3>
        <p>사용자 이름: {user.username}</p>
        {attributes && attributes.email && <p>이메일: {attributes.email}</p>}
      </div>
      
      <div className="dashboard-actions">
        <h3>기능</h3>
        <div className="action-cards">
          <Link to="/requests" className="action-card">
            <h4>📋 Tasks</h4>
            <p>요청 내역을 확인하고 관리합니다.</p>
          </Link>
          <Link to="/voice" className="action-card">
            <h4>🎤 음성 녹음</h4>
            <p>음성을 녹음하고 로컬 및 서버에 저장합니다.</p>
          </Link>
        </div>
      </div>
      
      <button onClick={handleSignOut}>로그아웃</button>
    </div>
  );
};

export default Dashboard;
